
import Form from "./Form.vue";
import GrupoData from "./GrupoData";
import { mapGetters } from "vuex";

export default {
  name: "app-grupos-create",
  data() {
    return {
      grupo: new GrupoData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
